import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector } from 'react-redux';
import { Info } from '../../../../../../assets/icons';
import { IReducer } from '../../../../../../redux/configureStore';
import { ILimit } from '../../../../../../redux/duck/legado/limitApp/interface/reduxInterfaces';
import Frame from '../../../../../../shared/components/Frame';
import { capitalize, cpfCnpjMask } from '../../../../../../utils/masks';
import ExportCsv from '../ExportCsv';
import ExportPdf from '../ExportPdf';
import BankInfoModal from './components/BankInfoModal';
import Button from './components/Button';
import PaginationComponent from './components/Pagination';
import TableComponent from './components/TableComponent';
import Text from './components/Text';
import Wrapper from './components/Wrapper';

function LimitTableList() {
  const limitDataState = useSelector((reducer: IReducer) => reducer.limitsApp);
  const limitState = useSelector((reducer: IReducer) => reducer.limitsApp);

  // If partner logged don't show partner column: start
  const profileState = useSelector((reducer: IReducer) => reducer.userProfile);
  function partnerIsLoggedLabel() {
    if (profileState.nivel !== 2) {
      return <></>;
    }
    return <TableComponent.Label>Parceiro</TableComponent.Label>;
  }
  function partnerIsLoggedColumn(show: string) {
    if (profileState.nivel !== 2) {
      return <></>;
    }
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip id="partner">{show}</Tooltip>}>
        <TableComponent.Data>{show}</TableComponent.Data>
      </OverlayTrigger>
    );
  }
  // If partner logged don't show partner column: end

  // Modal: start
  const [bankInfoModalShow, setBankInfoModalShow] = React.useState(false);
  const [dataBankInfoModalShow, setDataBankInfoModalShow] = React.useState(
    limitDataState[0]
  );
  function setBankInfoModal(props: ILimit) {
    setBankInfoModalShow(true);
    setDataBankInfoModalShow(props);
  }
  // Modal: end

  // Pagination: start
  const [data, setData] = useState(limitDataState.limits);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);
  function paginate(pageNumber: number) {
    setCurrentPage(pageNumber);
  }
  function setItensPerPage(event: any) {
    const { value } = event.currentTarget;
    setDataPerPage(value);
    setCurrentPage(1);
  }
  // Pagination: end

  // Search: start
  const [query, setQuery] = useState('');
  function search(rows: any) {
    if (rows !== undefined) {
      return rows.filter(
        (row: ILimit) =>
          row.cnpjCpf.indexOf(query) > -1 ||
          row.companyName.toLowerCase().indexOf(query.toLowerCase()) > -1
      );
    }
    return null;
  }
  useEffect(() => {
    setData(search(limitDataState.limits));
    setCurrentPage(1);
  }, [query]);
  // Search: end

  useEffect(() => {
    setData(limitDataState.limits);
    setCurrentPage(1);
  }, [limitDataState]);

  return (
    <Frame.Default
      isActive={limitState.gotSuccess && limitState.isActive}
      backgroundColor="#ffffff"
      padding="1rem"
      margin="0"
      flexDirection="column">
      <Wrapper.SearchAndButtons>
        <Wrapper.Search>
          <Text.Label>Buscar:</Text.Label>
          <Form.Control
            type="text"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Nome, CPF ou CNPJ"
          />
        </Wrapper.Search>
        <Wrapper.Buttons>
          {ExportPdf(limitDataState)}
          {ExportCsv(limitDataState)}
        </Wrapper.Buttons>
      </Wrapper.SearchAndButtons>
      <Wrapper.TableComponents>
        <TableComponent.Frame>
          <TableComponent.HeaderRow>
            <TableComponent.Head>
              <TableComponent.Label>ID</TableComponent.Label>
              <TableComponent.Label>Nome</TableComponent.Label>
              <TableComponent.Label>CPF/CNPJ</TableComponent.Label>
              {partnerIsLoggedLabel()}
              <TableComponent.Label>Informações</TableComponent.Label>
              <TableComponent.Label>Data de Referência</TableComponent.Label>
              <TableComponent.Label>Tipo de Limite</TableComponent.Label>
              <TableComponent.Label>Débito</TableComponent.Label>
            </TableComponent.Head>
          </TableComponent.HeaderRow>

          <TableComponent.Body>
            {currentData.map((client: ILimit) => {
              return (
                <TableComponent.Row key={client.id}>
                  <TableComponent.Id>{client.id}</TableComponent.Id>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id="name">
                        {capitalize(client.companyName)}
                      </Tooltip>
                    }>
                    <TableComponent.Data>
                      {capitalize(client.companyName)}
                    </TableComponent.Data>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id="cpfCnpj">
                        {cpfCnpjMask(client.cnpjCpf)}
                      </Tooltip>
                    }>
                    <TableComponent.Data>
                      {cpfCnpjMask(client.cnpjCpf)}
                    </TableComponent.Data>
                  </OverlayTrigger>
                  {partnerIsLoggedColumn(client.partner)}
                  <TableComponent.Data>
                    <Button.Info onClick={() => setBankInfoModal(client)}>
                      <Info />
                    </Button.Info>
                  </TableComponent.Data>
                  <TableComponent.Data>
                    {moment(client.referenceDate).format('DD/MM/YYYY')}
                  </TableComponent.Data>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="type">{client.type}</Tooltip>}>
                    <TableComponent.Data>{client.type}</TableComponent.Data>
                  </OverlayTrigger>
                  <TableComponent.Balance value={Number(client.value)}>
                    {Number(client.value).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponent.Balance>
                </TableComponent.Row>
              );
            })}
          </TableComponent.Body>
        </TableComponent.Frame>
        <Wrapper.Pagination>
          <Form.Control
            as="select"
            onChange={(event) => setItensPerPage(event)}
            style={{ marginRight: '1rem' }}>
            <option key={14} value={10}>
              10
            </option>
            <option key={13} value={25}>
              25
            </option>
            <option key={12} value={50}>
              50
            </option>
            <option key={11} value={limitDataState.limits.length}>
              Todos
            </option>
          </Form.Control>
          <PaginationComponent
            dataPerPage={dataPerPage}
            totalData={data.length}
            currentPage={currentPage}
            paginate={(e) => paginate(e)}
          />
        </Wrapper.Pagination>

        <BankInfoModal
          show={bankInfoModalShow}
          onHide={() => setBankInfoModalShow(false)}
          data={dataBankInfoModalShow}
        />
      </Wrapper.TableComponents>
    </Frame.Default>
  );
}

export default LimitTableList;
